<template>
  <el-dialog
    :title="name"
    :visible.sync="dialogVisible"
    width="60%"
    :before-close="handleClose"
  >
    <el-form ref="from" :model="adminHouse" label-width="100px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="操作员姓名">
            {{ name }}
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-form-item label="房产权限">
          <div style="width: 100%; max-height: 200px; overflow-y: scroll">
            <el-tag
              v-for="(item, key) in adminHouse.houseNames"
              :key="key"
              style="margin-right: 3px"
            >
              {{ item }}
            </el-tag>
          </div>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="可选房产">
          <el-button size="mini" @click="choiceAll"> 全选</el-button>
          <el-button size="mini" @click="cancelAll"> 清空</el-button>
          <el-dropdown size="mini" @command="handleCommand" trigger="click">
            <el-button size="mini" style="margin-left: 9px">
              战区 <i class="el-icon-arrow-down el-icon--right"> </i>
            </el-button>
            <el-dropdown-menu slot="dropdown" style="height: 500px; overflow: scroll;">
              <el-dropdown-item
                v-for="item in zoneList"
                :key="item.id"
                :command="item.id"
              >
                {{ item.name }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button size="mini" @click="getProjectList"> 刷新</el-button>
          <el-input placeholder="输入关键字进行过滤" v-model="filterText" />
          <div style="width: 100%; height: 400px; overflow-y: scroll">
            <el-tree
              ref="tree"
              :data="pindexList"
              :props="defaultProps"
              :lazy="true"
              :load="getData"
              node-key="id"
              show-checkbox
              :default-checked-keys="adminHouse.houseIds"
              :filter-node-method="filterNode"
            />
          </div>
        </el-form-item>
      </el-row>
      <el-form-item>
        <el-button type="primary" plain @click="save(1)">添加</el-button>
        <el-button type="primary" plain @click="save(2)">替换</el-button>
        <el-button plain @click="handleClose">取消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import Http from "@/components/Admin/Flow/common/Http";
export default {
  name: "OperatorPropertySelect",
  props: {
    mode: {
      type: String,
      default: "view",
    },
    id: {
      type: Number | String,
      default: null,
    },
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      pindexList: [],
      defaultProps: {
        // label: 'name',
        children: "",
        label: "name",
      },
      adminHouse: {
        houseIds: [],
        houseNames: [],
      },
      defaultcheckedkeys: [],
      count: 1,
      zoneList: [],
      zoneId: "",
      node: [],
      resolve: [],
      filterText: "",
    };
  },
  mounted() {
    this.getProjectList();
    this.getAdminHouse();
    this.getZoneList();
  },
  watch: {
    id(n, o) {
      if (this.count == 1) {
        this.count = 2;
      } else {
        this.$refs.tree.setCheckedKeys([]);
      }
      this.getAdminHouse();
    },
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  methods: {
    // 获取自己名下的战区
    getZoneList() {
      this.$myhttp
        .post(
          "admin/common/zones",
          {},
          {
            "Content-Type": "application/json",
          }
        )
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.zoneList = backdata.data.data;
          } else {
            this.$message.error(backdata.data.message);
          }
        });
    },
    // 获得自己名下的所有项目
    getProjectList() {
      this.$myhttp
        .post(
          "admin/common/getChildProjectList",
          { parentId: 0, level: 1 },
          {
            "Content-Type": "application/json",
          }
        )
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.pindexList = backdata.data.data.map((item) => {
              return {
                name: item.house_name,
                id: item.house_id,
                level: item.level,
              };
            });
          } else {
            this.$message.error(backdata.data.message);
          }
        });
    },
    getData(node, resolve) {
      setTimeout(() => {
        var level = 0;
        var parentId = 0;
        if (node.data != undefined) {
          level = node.data.level;
          parentId = node.data.id;
        }
        level = level + 1;
        // if (node.level === 0) {
        //   this.node = node;
        //   this.resolve = resolve;
        // }
        //加载
        this.$myhttp
          .post(
            "admin/common/getChildProjectList",
            { parentId: parentId, level: level, zoneId: this.zoneId },
            {
              "Content-Type": "application/json",
            }
          )
          .then((backdata) => {
            var listData;
            listData = backdata.data.data.map((item) => {
              return {
                name: item.house_name,
                id: item.house_id,
                level: item.level,
              };
            });
            return resolve(listData);
          });
      }, 300);
    },
    getAdminHouse() {
      if (this.id == null || this.id == 0) {
        return;
      }
      Http.post("hr/User/getUserProjectList", { id: this.id }, (res) => {
        this.adminHouse = res.data;
      });
    },
    handleClose() {
      this.$emit("close", false);
    },
    save(type) {
      if (this.id == null || this.id == 0) {
        return;
      }
      var checkedKeys = this.$refs.tree.getCheckedKeys(); //获得全选状态id
      // var halfCheckedKeys = this.$refs.tree.getHalfCheckedKeys(); //获得半选状态的id
      // var houseIds = checkedKeys.concat(halfCheckedKeys); //数组组合
      var houseIds = checkedKeys;
      Http.post(
        "hr/User/editUserProjectRight",
        { id: this.id, houseIds, type },
        (res) => {
          if (res.code == 0) {
            this.$message.success(res.msg);
            this.getAdminHouse();
            this.handleClose();
          } else {
            this.$message.error(res.msg);
            this.handleClose();
          }
        }
      );
    },
    choiceAll() {
      const keys = this.pindexList.map((item) => {
        return item.id;
      });
      this.$refs.tree.setCheckedKeys(keys);
    },
    cancelAll() {
      this.$refs.tree.setCheckedKeys([]);
    },
    handleCommand(command) {
      this.zoneId = command;
      this.$myhttp
        .post(
          "admin/common/getChildProjectList",
          { parentId: 0, level: 1, zoneId: this.zoneId },
          {
            "Content-Type": "application/json",
          }
        )
        .then((backdata) => {
          this.pindexList = backdata.data.data.map((item) => {
            return {
              name: item.house_name,
              id: item.house_id,
              level: item.level,
            };
          });
        });
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Admin/Config/Operator/OperatorPropertySelect.vue